<template>
    <div class="app">
        <scroll>
            <section>
                <dl class="field" style="height: 65px">
                    <span class="f-strong f-middle">订单号：{{ orderId }}</span>
                    <dd class="right-item f-strongest f-largest">{{ fee | formatFee }}</dd>
                </dl>
            </section>
            <section v-show="paySuccess" class="pay-success-bg">
                <div class="success-photo"></div>
                <label class="f-largest" style="margin: 10px">预约成功，请在医院规定时间前往
                    <br>医院支付挂号费取号！
                </label>
            </section>
            <section v-show="payFailed" class="pay-success-bg">
                <div class="failed-photo"></div>
                <label class="f-largest">{{ message }}</label>
            </section>
            <section v-show="payOvertime" class="pay-success-bg">
                <div class="failed-photo"></div>
                <label class="f-largest">网络错误，请稍后重试</label>
            </section>
        </scroll>
        <footer>
            <button class="btn-finished" v-show="paySuccess || payOvertime" @click="finished(true)">完成</button>
            <button class="btn-finished" v-show="payFailed" @click="finished(false)">完成</button>
        </footer>
    </div>
</template>
<script>

    export default {
        data(){
            return {
                fee: '0',
                orderId: '0',
                cardType: '',
                cardNo: '',
                startDate: '',
                endDate: '',
                busiType: '',
                pay: {},
                payFailed: false,
                paySuccess: false,
                payOvertime: false,
                paySuccessInfo: {},
                bookingResultInfo: {},
                message:'',
            }
        },
        mounted(){
            //获取上级传入参数
            this.bookingResultInfo = this.$store.state.paramModule.param.BookingResult.registerInfo;
            this.fee = this.bookingResultInfo.fee;
            this.orderId = this.bookingResultInfo.orderId;
            this.busiType = this.bookingResultInfo.busiType;
            this.cardNo = this.bookingResultInfo.cardNo;
            this.cardType = this.bookingResultInfo.cardType;
            this.message = this.bookingResultInfo.message
            this.refresh();
        },
        methods: {
            refresh() {
                if (this.bookingResultInfo.bookingResult === true) {
                    this.paySuccess = true;
                } else {
                    this.payFailed = true;
                }
            },

            //跳转挂号列表
            finished(flag){
                if (flag === true) {
                    //将数据存入本地
                    this.$store.commit('updateParam', {
                        namespace: 'regDetail',
                        isPaySuccess: false,
                        registerInfo: {
                            cardType: this.cardType,
                            cardNo: this.cardNo,
                            orderType: this.constant.ORDER_TYPE.REGISTRATION_TYPE,
                            orderId: this.orderId
                        }
                    });
                    this.$router.push('regdetail');
                } else {
                    this.$router.replace('/')
                }
            }
        }
    }
</script>

<style lang="scss">
    .pay-success-bg {
        top: 3.8rem;
        right: 0rem;
        bottom: 0rem;
        left: 0rem;
        background-color: white;
        position: absolute;
        text-align: center
    }
</style>



// WEBPACK FOOTER //
// BookingResult.vue?11417b04